import { SoapSectionKeys } from '@/shared/types/yakurekiSoap'

import { KakeruActionName, SoupKbn } from '../types/embed'

// AnyCOMPASS iframe 連携の定数(action 名・親 origin 許可リスト・SOAP 区分マップ)。
// 設計正本: medigital-hub log/04 work-log/01_iframe_wiring_protocol.md。

// postMessage の actionName。親 React 側の定義と 1 文字も違えない。
export const KAKERU_MSG = {
  READY: 'KAKERU_READY',
  INIT: 'KAKERU_INIT',
  APPLY_SOAP: 'KAKERU_APPLY_SOAP',
} as const satisfies Record<string, KakeruActionName>

// 親(AnyCOMPASS)origin の許可リスト。ここに載る origin からの INIT のみ信用し、
// APPLY_SOAP の送信先も検証済み origin に固定する(targetOrigin='*' は使わない)。
// env 駆動: VITE_ANYCOMPASS_ORIGINS = カンマ区切り。未設定(=通常の単体起動)なら空 =
// ハンドシェイク不成立 = embed 機能オフ。
export const ANYCOMPASS_PARENT_ORIGINS: readonly string[] = (
  import.meta.env.VITE_ANYCOMPASS_ORIGINS ?? ''
)
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean)

// Kakeru の SOAP セクションキー → AnyCOMPASS SoapKbn。
// followup_plans / home_visit 系は薬歴の SOAP 区分に対応しないため転記対象外(ここに載せない)。
export const SOAP_SECTION_TO_SOUP_KBN: Record<SoapSectionKeys, SoupKbn> = {
  subjectives: 1, // S
  objectives: 2, // O
  assessments: 3, // A
  educational_plans: 4, // EP
  observational_plans: 5, // OP
  care_plans: 6, // CP
}

// 転記行を並べる順。UI の SOAP 表示順(S→O→A→EP→CP→OP)に一致させる。
//
// ※ SOAP_SECTION_TO_SOUP_KBN のキー順を流用してはならない。あちらは AnyCOMPASS の
//   SoupKbn 採番順(OP=5, CP=6)なので CP/OP が入れ替わり、転記の並びが変わってしまう。
//   この並びは元々 apps/latest 側の SOAP_SECTIONS が持っていたが、feature から apps を
//   参照しない(逆流禁止)ためここに持ち直した。
export const ANYCOMPASS_TRANSFER_SECTION_ORDER: readonly SoapSectionKeys[] = [
  'subjectives',
  'objectives',
  'assessments',
  'educational_plans',
  'care_plans',
  'observational_plans',
]
